import { FC, useEffect } from "react";

//!COMPONENTS
import Breadcrumbs from "components/breadcrumbs";
import Stylo from "components/stylo";
import AppScreen from "../ScreenWithSidebar";

//!STYLE
import s from "./assets/success.module.css";

import { useDispatch } from "react-redux";
import {
  setShowDrawerPaiementOneMoreTimeHandler
} from "store/auth/authSlice";
import AnimatedPage from "utils/animatedPage";

import Albert from "../../../assets/images/albert/albert_empty_data.svg";

const Failing: FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setShowDrawerPaiementOneMoreTimeHandler());
  }, []);

  return (
    <AnimatedPage>
      <Stylo />

      <Breadcrumbs />
      <AppScreen>
        <div className={s.container}>
          <div className={s.card}>
            <div
              style={{
                height: "200px",
                width: "200px",
                margin: "0 auto",
              }}
            >
              <img src={Albert} height={150}></img>
            </div>
            <h1 className={s.title} style={{ color: "red" }}>
              Echec
            </h1>
            <p className={s.paragraph}>
              {/* votre demande d'achat n'a pas été prise en compte suite à une
              erreur inattendue
              <br />
              Mon ami Albert vous remercie pour votre compréhension. <br />
              On vous invite à refaire l'achat encore une fois,
              <Link to="/"> pour cela cliquer ici</Link> */}
              La recharge de votre portefeuille a échoué,<br />merci de réessayer plus tard ou de nous<br />contacter par email à : support@monamialbert.com.
            </p>
          </div>
        </div>
      </AppScreen>
    </AnimatedPage>
  );
};

export default Failing;
